import { PanelPaths } from 'appShared/paths';
import { FeatureEnum, PermissionRuleCheckStrategiesEnum, PermissionsEnum } from 'appShared/enums';

import { SidebarDescriptorInterface } from 'appEntries/panel/components/sidebar';
import { PermissionRulesTrait } from 'appEntries/panel/traits/permission-rules.trait';
import { AmsPermissionRulesTrait } from 'appEntries/panel/traits/ams-permission-rules.trait';
import { Helper } from 'appShared/classes';

export const SidebarDescriptor: SidebarDescriptorInterface[] = [
    {
        title: 'Customers',
        items: [
            {
                title: 'Leads',
                icon: 'fa-handshake-o',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.leads.path,
                children: [],

                permissionRule: PermissionRulesTrait.getViewClientDetailsPermissionRule()
            },
            {
                title: 'Verifications',
                icon: 'fa-check-square-o',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.verifications.path,
                children: [],

                permissionRule: PermissionRulesTrait.getViewClientDetailsPermissionRule()
            },
            {
                title: 'Clients',
                icon: 'fa-id-card-o',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.clients.path,
                children: [],

                permissionRule: PermissionRulesTrait.getViewClientDetailsPermissionRule()
            },
            {
                title: 'Client Users',
                icon: 'fa-user-circle-o',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.clientUsers.path,
                children: [],

                permissionRule: PermissionRulesTrait.getViewClientUsersPermissionRule()
            },
            {
                title: 'Documents',
                icon: 'fa-file-text-o',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.documents.path,
                children: [],

                permissionRule: PermissionRulesTrait.getViewDocumentsPermissionRule()
            },
            {
                title: 'Payment Accounts',
                icon: 'fa-university',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.bankAccounts.path,
                children: [],

                permissionRule: {
                    permissions: [
                        PermissionsEnum.CrmBankAccountsCreateNew,
                        PermissionsEnum.CrmBankAccountsViewDetails,
                        PermissionsEnum.CrmBankAccountsUpdateDetails
                    ],
                    strategy: PermissionRuleCheckStrategiesEnum.Union
                }

            },
            {
                title: 'Messages',
                icon: 'fa-envelope',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.messages.path,
                children: [],
                permissionRule: AmsPermissionRulesTrait.getMessageRequestViewPermissionRule()
            }
        ],
        permissionRule: {
            permissions: [
                ...PermissionRulesTrait.getViewClientDetailsPermissionRule().permissions,
                ...PermissionRulesTrait.getViewClientUsersPermissionRule().permissions,
                ...PermissionRulesTrait.getViewDocumentsPermissionRule().permissions
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        }
    },
    {
        title: 'Financial/Trading',
        items: [
            {
                title: 'Payments',
                icon: 'fa-exchange',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.payments.path,
                children: [],

                permissionRule: {
                    permissions: [
                        PermissionsEnum.CrmPaymentsCreateNewTransfer,
                        PermissionsEnum.CrmPaymentsCreateNewDeposit,
                        PermissionsEnum.CrmPaymentsCreateNewWithdrawal,
                        PermissionsEnum.CrmPaymentsViewDetails,
                        PermissionsEnum.CrmPaymentsUpdateDetails
                    ],
                    strategy: PermissionRuleCheckStrategiesEnum.Union
                }
            },
            {
                title: 'Accounts',
                icon: 'fa-suitcase',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.accounts.path,
                children: [],

                permissionRule: {
                    permissions: [
                        PermissionsEnum.CrmTradingAccountsCreateNew,
                        PermissionsEnum.CrmTradingAccountsViewDetails,
                        PermissionsEnum.CrmTradingAccountsUpdateDetails,
                        PermissionsEnum.CrmCashAccountsCreateNew,
                        PermissionsEnum.CrmCashAccountsViewDetails,
                        PermissionsEnum.CrmCashAccountsUpdateDetails,
                    ],
                    strategy: PermissionRuleCheckStrategiesEnum.Union
                }
            },
            {
                title: 'Orders',
                icon: 'fa-tag',
                toggled: false,
                link: `/${PanelPaths.root}/${PanelPaths.children.orders.path}`,

                children: [],

                permissionRule: PermissionRulesTrait.getViewOrdersPermissionRule()
            },
            {
                title: 'Coupon Distributions',
                icon: 'fa-list-ol',
                toggled: false,
                link: `/${PanelPaths.root}/${PanelPaths.children.couponBonds.path}`,

                children: [],

                get hidden() {
                    return !Helper.isFeatureEnabled(FeatureEnum.BondCouponPayments);
                },
                permissionRule: PermissionRulesTrait.getViewBondCouponsPermissionRule()
            },
            {
                title: 'Referral Payouts',
                icon: 'fa-exchange',
                toggled: false,
                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.referralPayouts.path
                ].join('/'),

                children: [],

                get hidden() {
                    return !Helper.isFeatureEnabled(FeatureEnum.ReferralProgram);
                },
                permissionRule: PermissionRulesTrait.getProcessReferralPayoutsPermissionRule()
            },
            {
                title: 'Reports',
                icon: 'fa-flag-o',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.reports.path,

                children: [
                    {
                        title: 'Account Reports',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.reports.path,
                            PanelPaths.children.reports.children.accountReports.path
                        ].join('/'),
                        permissionRule: PermissionRulesTrait.getReportsViewPermissionRule()

                    },
                    {
                        title: 'Group Reports',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.reports.path,
                            PanelPaths.children.reports.children.groupReports.path
                        ].join('/'),
                        permissionRule: PermissionRulesTrait.getReportsViewPermissionRule()

                    },
                    {
                        title: 'Executions',
                        toggled: false,
                        link: '/' + PanelPaths.root + '/' + PanelPaths.children.reports.children.executionsReports.path,
                        children: [
                            {
                                title: 'Equities',
                                toggled: false,
                                children: [],
                                link: '/' + [
                                    PanelPaths.root,
                                    PanelPaths.children.reports.path,
                                    PanelPaths.children.reports.children.executionsReports.path,
                                    PanelPaths.children.reports.children.executionsReports.children.equities.path
                                ].join('/')
                            },
                            {
                                title: 'Fx',
                                toggled: false,
                                children: [],
                                link: '/' + [
                                    PanelPaths.root,
                                    PanelPaths.children.reports.path,
                                    PanelPaths.children.reports.children.executionsReports.path,
                                    PanelPaths.children.reports.children.executionsReports.children.fx.path
                                ].join('/')
                            }
                        ],
                        permissionRule: PermissionRulesTrait.getReportsViewPermissionRule()


                    },
                    {
                        title: 'Market data usage',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.marketData.path,
                            PanelPaths.children.marketData.children.usageReports.path,
                        ].join('/'),
                        permissionRule: PermissionRulesTrait.getMarketDataUsageReportsViewPermissionRule()
                    },
                    {
                        title: 'Referral reports',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.reports.path,
                            PanelPaths.children.reports.children.referralReports.path,
                        ].join('/'),
                        permissionRule: PermissionRulesTrait.getReportsViewPermissionRule()

                    },
                    {
                        title: 'Referral & Commission',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.reports.path,
                            PanelPaths.children.reports.children.referralCommissions.path,
                        ].join('/'),

                        get hidden() {
                            return !Helper.isFeatureEnabled(FeatureEnum.ReferralProgram);
                        },
                        permissionRule: PermissionRulesTrait.getReportsViewPermissionRule()
                    },
                    {
                        title: 'Payout Requests',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.reports.path,
                            PanelPaths.children.reports.children.referralPayoutsReport.path,
                        ].join('/'),

                        get hidden() {
                            return !Helper.isFeatureEnabled(FeatureEnum.ReferralProgram);
                        },
                        permissionRule: PermissionRulesTrait.getReportsViewPermissionRule()
                    },
                    {
                        title: 'Marketing reports',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.reports.path,
                            PanelPaths.children.reports.children.marketing.path,
                        ].join('/'),
                        permissionRule: PermissionRulesTrait.getMarketingReportsViewPermissionRule()
                    },
                    {
                        title: 'Campaign Funnel',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.reports.path,
                            PanelPaths.children.reports.children.campaignReports.path,
                        ].join('/'),
                        permissionRule: PermissionRulesTrait.getMarketingReportsViewPermissionRule()
                    },

                ],

                permissionRule: {permissions: [
                        ...PermissionRulesTrait.getReportsViewPermissionRule().permissions,
                        ...PermissionRulesTrait.getMarketingReportsViewPermissionRule().permissions,
                        ...PermissionRulesTrait.getMarketDataUsageReportsViewPermissionRule().permissions,
                    ],
                    strategy: PermissionRuleCheckStrategiesEnum.Union}
            },
            {
                title: 'Create Adjustments',
                icon: 'fa-arrows-v',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.bulkPayments.path,
                children: [],
                permissionRule: PermissionRulesTrait.getViewPaymentsBulkPermissionRule()
            },
            {
                title: 'Platform Frontends',
                icon: '',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.platformFrontends.path,
                children: [],
                permissionRule: PermissionRulesTrait.getPlatformFrontendManagementPermissionRule()
            },
            {
                title: 'Exchanges',
                icon: '',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.exchange.path,
                children: [],
                permissionRule: PermissionRulesTrait.getMarketDataFeedManagementPermissionRule(PermissionRuleCheckStrategiesEnum.Union)
            },
            {
                title: 'Plans',
                icon: '',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.plans.path,
                children: [],
                hidden: !Helper.isFeatureEnabled(FeatureEnum.TradingPlans),
                permissionRule: PermissionRulesTrait.getTradingPlansViewPermissionRule(PermissionRuleCheckStrategiesEnum.Union)
            },
            {
                title: 'Routes',
                icon: 'fa-exchange',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.orderRoutes.path,
                children: [],
                permissionRule: PermissionRulesTrait.getOrderRoutesViewPermissionRule(PermissionRuleCheckStrategiesEnum.Union)
            },
        ],
        permissionRule: {
            permissions: [
                PermissionsEnum.CrmPaymentsCreateNewTransfer,
                PermissionsEnum.CrmPaymentsCreateNewDeposit,
                PermissionsEnum.CrmPaymentsCreateNewWithdrawal,
                PermissionsEnum.CrmPaymentsViewDetails,
                PermissionsEnum.CrmPaymentsUpdateDetails,
                PermissionsEnum.CrmTradingAccountsCreateNew,
                PermissionsEnum.CrmTradingAccountsViewDetails,
                PermissionsEnum.CrmTradingAccountsUpdateDetails,
                PermissionsEnum.CrmCashAccountsCreateNew,
                PermissionsEnum.CrmCashAccountsViewDetails,
                PermissionsEnum.CrmCashAccountsUpdateDetails,
                PermissionsEnum.CrmReportsAll,
                PermissionsEnum.CrmReportsViewPredefinedReports,
                PermissionsEnum.CRMReportsViewMarketingReports,
                ...PermissionRulesTrait.getPlatformFrontendManagementPermissionRule().permissions,
                ...PermissionRulesTrait.getViewBondCouponsPermissionRule().permissions,
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        }
    },
    {
        title: 'Market Data',
        items: [
            {
                title: 'Feeds',
                icon: '',
                toggled: false,

                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.marketData.path,
                    PanelPaths.children.marketData.children.feeds.path,
                ].join('/'),

                children: [],
                permissionRule:
                    PermissionRulesTrait.getMarketDataFeedAndBundleViewPermissionRule(PermissionRuleCheckStrategiesEnum.Union)
            },
            {
                title: 'Entitlement reports',
                icon: '',
                toggled: false,

                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.marketData.path,
                    PanelPaths.children.marketData.children.entitlementReports.path,
                ].join('/'),

                children: [],
                permissionRule:
                    PermissionRulesTrait.getEntitlementReportViewPermissionRule()
            },
            {
                title: 'Service Users',
                icon: '',
                toggled: false,

                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.marketData.path,
                    PanelPaths.children.marketData.children.serviceUsers.path,
                ].join('/'),

                children: [],
                permissionRule: {
                    permissions: [
                        ...PermissionRulesTrait.getServiceUserViewPermissionRule().permissions,
                    ],
                    strategy: PermissionRuleCheckStrategiesEnum.Union
                }
            },
            {
                title: 'Event History',
                icon: '',
                toggled: false,

                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.marketData.path,
                    PanelPaths.children.marketData.children.eventHistory.path,
                ].join('/'),

                children: [],
                permissionRule: PermissionRulesTrait.getEventHistoryViewPermissionRule()
            },
        ],
        permissionRule: {
            permissions: [
                ...PermissionRulesTrait.getMarketDataFeedAndBundleViewPermissionRule().permissions,
                ...PermissionRulesTrait.getEventHistoryViewPermissionRule().permissions,
                ...PermissionRulesTrait.getEntitlementReportViewPermissionRule().permissions,
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        }
    },
    {
        title: 'Settings',
        items: [
            {
                title: 'Messaging',
                icon: 'fa-envelope',
                toggled: false,
                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.settings.path,
                    PanelPaths.children.settings.children.messages.path
                ].join('/'),
                children: [
                    {
                        title: 'Email Templates',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.settings.path,
                            PanelPaths.children.settings.children.messages.path,
                            PanelPaths.children.settings.children.messages.children.emailTemplates.path,
                        ].join('/'),
                        permissionRule: AmsPermissionRulesTrait.getAmsEmailTemplateViewPermissionRule()
                    },
                    {
                        title: 'Message Templates',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.settings.path,
                            PanelPaths.children.settings.children.messages.path,
                            PanelPaths.children.settings.children.messages.children.messageTemplates.path,
                        ].join('/'),
                        permissionRule: AmsPermissionRulesTrait.getAmsMessageTemplateViewPermissionRule()
                    },
                ],
                permissionRule: AmsPermissionRulesTrait.getAmsMessagingMenuViewPermissionRule()
            },
            {
                title: 'Roles',
                icon: 'fa-lock',
                toggled: false,
                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.settings.path,
                    PanelPaths.children.settings.children.roles.path
                ].join('/'),

                children: [],

                permissionRule: {
                    permissions: [
                        PermissionsEnum.CrmOperatorsAndRolesCreateNewRole,
                        PermissionsEnum.CrmOperatorsAndRolesViewUsersRoles,
                        PermissionsEnum.CrmOperatorsAndRolesUpdateRole
                    ],
                    strategy: PermissionRuleCheckStrategiesEnum.Union
                }
            },
            {
                title: 'Operators',
                icon: 'fa-group',
                toggled: false,
                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.settings.path,
                    PanelPaths.children.settings.children.operators.path
                ].join('/'),

                children: [],

                permissionRule: {
                    permissions: [
                        PermissionsEnum.CrmOperatorsAndRolesCreateNewOperator,
                        PermissionsEnum.CrmOperatorsAndRolesViewUser,
                        PermissionsEnum.CrmOperatorsAndRolesUpdateOperator
                    ],
                    strategy: PermissionRuleCheckStrategiesEnum.Union
                }
            },
            {
                title: 'Groups',
                icon: 'fa-user-plus',
                toggled: false,
                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.settings.path,
                    PanelPaths.children.settings.children.groups.path
                ].join('/'),

                children: [],

                permissionRule: PermissionRulesTrait.getViewGroupsPermissionRule()
            },
            {
                title: 'Audit',
                icon: 'fa-eye',
                toggled: false,
                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.settings.path,
                    PanelPaths.children.settings.children.audit.path
                ].join('/'),

                children: [],

                permissionRule: {
                    permissions: [PermissionsEnum.CrmAuditTrailAll, PermissionsEnum.CrmAuditTrailView],
                    strategy: PermissionRuleCheckStrategiesEnum.Intersect
                }
            },
            {
                title: 'Products',
                icon: 'fa fa-cube',
                toggled: false,
                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.settings.path,
                    PanelPaths.children.settings.children.products.path
                ].join('/'),

                children: [],

                permissionRule: PermissionRulesTrait.getViewProductsPermissionRule()
            },
            {
                title: 'Closeout Plans',
                icon: 'fa-shield',
                toggled: false,
                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.settings.path,
                    PanelPaths.children.settings.children.closeoutPlans.path
                ].join('/'),
                children: [
                    {
                        title: 'Plans',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.settings.path,
                            PanelPaths.children.settings.children.closeoutPlans.path,
                            PanelPaths.children.settings.children.closeoutPlans.children.plans.path
                        ].join('/'),
                        permissionRule: PermissionRulesTrait.getCloseoutPlansViewPermissionRule()
                    },
                    {
                        title: 'Assignment Rules',
                        toggled: false,
                        link: '/' + [
                            PanelPaths.root,
                            PanelPaths.children.settings.path,
                            PanelPaths.children.settings.children.closeoutPlans.path,
                            PanelPaths.children.settings.children.closeoutPlans.children.assignmentRules.path
                        ].join('/'),
                        permissionRule: PermissionRulesTrait.getCloseoutPlansViewPermissionRule()
                    },
                ],
                get hidden() {
                    return !Helper.isFeatureEnabled(FeatureEnum.CloseoutPlans);
                },
                permissionRule: PermissionRulesTrait.getCloseoutPlansViewPermissionRule()
            },
            {
                title: 'Coupon Codes',
                icon: '',
                toggled: false,
                link: '/' + PanelPaths.root + '/' + PanelPaths.children.coupons.path,
                children: [],
                hidden: !Helper.isFeatureEnabled(FeatureEnum.TradingPlans),
                permissionRule: PermissionRulesTrait.getCouponsViewPermissionRule(PermissionRuleCheckStrategiesEnum.Union)
            },
            {
                title: 'File Import',
                icon: 'fa-upload',
                toggled: false,
                link: '/' + [
                    PanelPaths.root,
                    PanelPaths.children.settings.path,
                    PanelPaths.children.settings.children.fileImport.path
                ].join('/'),

                children: [],

                permissionRule: {
                    permissions: [PermissionsEnum.CrmFileImportAll, PermissionsEnum.CrmFileImportClientsAndAccounts],
                    strategy: PermissionRuleCheckStrategiesEnum.Intersect
                }
            },
        ],

        permissionRule: {
            permissions: [
                PermissionsEnum.CrmOperatorsAndRolesCreateNewRole,
                PermissionsEnum.CrmOperatorsAndRolesViewUsersRoles,
                PermissionsEnum.CrmOperatorsAndRolesUpdateRole,
                PermissionsEnum.CrmOperatorsAndRolesCreateNewOperator,
                PermissionsEnum.CrmOperatorsAndRolesViewUser,
                PermissionsEnum.CrmOperatorsAndRolesUpdateOperator,
                ...PermissionRulesTrait.getViewGroupsPermissionRule().permissions,
                ...PermissionRulesTrait.getViewProductsPermissionRule().permissions,
                ...PermissionRulesTrait.getCloseoutPlansViewPermissionRule().permissions,
                PermissionsEnum.CrmAuditTrailAll,
                PermissionsEnum.CrmAuditTrailView,
                PermissionsEnum.CrmFileImportAll,
                PermissionsEnum.CrmFileImportClientsAndAccounts
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        }
    },
];
